import * as yup from "yup"
import { User } from "../../types"

export function initialValuesUtente(utente?: User | undefined) {
  if (utente) {
    return utente
  }
  return {
    full_name: "",
    email: "",
    can_delete_data: true,
  }
}

export function validationSchemaUtente() {
  return yup.object().shape({
    full_name: yup.string().required("Campo obbligatorio"),
    email: yup.string().email("Email non valida").required("Campo obbligatorio"),
  })
}
